<template>
<div class="animated fadeIn">


  <transition name="fade">

    <CRow>

      <ConfirmationModal
        v-if="parkingsPlansClient"
        v-bind:show="modalRenewProduct"
        :title="confirmTitle"
        confirmText='Aceptar'
        cancelText='Cancelar'
        @cancel="resetRenewal"
        @confirm="updateRenewal"
      >
      <!-- Actualizar renovación automática -->

      <!-- {{ parkingsPlansClient.amount.toFixed(2)}} € -->
        <p v-if="parkingsPlansClient && parkingsPlansClient.renewal">
          <!-- total_amount -->
          El Plan se renovará automáticamente y se cobrará en la tarjeta de crédito el importe correspondiente 
          <span v-if="parkingsPlansClient.next_payment_date"> el día {{ formatDateCustom(parkingsPlansClient.next_payment_date) }}, </span>
          un día antes que vez venza el periodo actual de contratación el {{ formatDateCustom(parkingsPlansClient.end_datetime) }}.
        </p>

        <p v-else>
          El plan no se renovará automáticamente una vez venza el periodo actual 
          de contratación el {{ formatDateCustom(parkingsPlansClient.end_datetime) }}
        </p>

        <small class="text-primary">* Una vez completado el proceso estará activo el plan actualizado</small>

      </ConfirmationModal>

      <CCol sm="12">

        <SpinnerCircle :show="loading" />

        <div v-if="!loading">

          <CRow v-if="parkingsPlansClient">

            <div class="col-md-3">
              <CCard :no-body="true">
                <CCardBody class="p-0 clearfix">
                  <i class="fa fa-clock-o bg-gradient-primary text-white p-4 font-2xl mr-3 float-left"
                  v-if="parkingsPlansClient.plans_id == 1"></i>

                  <i class="fa fa-pie-chart bg-gradient-primary text-white p-4 font-2xl mr-3 float-left"
                    v-else ></i>

                  <div class="h6 text-dark mb-0 pt-3">
                    <b v-if="parkingsPlansClientsToEdit.plan"
                      >{{ parkingsPlansClientsToEdit.plan.name }}
                    </b>
                    <b v-if="productType == CUSTOM.key"> {{ CUSTOM.element }} </b>
                    <b v-if="productType == PRUEBA.key">{{ PRUEBA.element }}</b>

                  </div>
                  <div class="text-muted text-uppercase font-weight-bold font-xs">
                    Plan
                    </div>
                </CCardBody>
              </CCard>
            </div>

            <div v-if="!parkingsPlansClientsToEdit.parking.deleted_at" class="col-md-3 card-detail-buttons">
              <router-link :to="'/parkings/' + parkingsPlansClientsToEdit.parking.id">
              <CCard :no-body="true">
                <CCardBody class="p-0 clearfix">
                  <i class="fa fa-motorcycle bg-gradient-info text-white p-4 font-2xl mr-3 float-left"
                    v-c-tooltip.hover.click="'Ver parking'"></i>

                  <div class="h6 text-dark mb-0 pt-3"><b>{{ parkingsPlansClientsToEdit.parking.name }}</b></div>
                  <div class="text-muted text-uppercase font-weight-bold font-xs">
                    Parking
                    </div>
                </CCardBody>
              </CCard>
              </router-link>
            </div>

            <div v-else class="col-md-3">
              <CCard :no-body="true">
                <CCardBody class="p-0 clearfix">
                  <i class="fa fa-motorcycle bg-gradient-info text-white p-4 font-2xl mr-3 float-left"></i>
                  <div class="h6 text-dark mb-0 pt-3"><b>{{ parkingsPlansClientsToEdit.parking.name }}</b></div>
                  <div class="text-muted text-uppercase font-weight-bold font-xs">
                    Parking
                    </div>
                </CCardBody>
              </CCard>
            </div>


            <div class="col-md-3">
              <CCard :no-body="true">
                <CCardBody class="p-0 clearfix">
                  <i class="fa fa-eur bg-gradient-success text-white p-4 font-2xl mr-3 float-left"></i>
                  <div class="h6 text-dark mb-0 pt-3"><b>{{ stringUtils.formatStringPrice(parkingsPlansClientsToEdit.total_amount)}} €</b></div>
                  <div class="text-muted text-uppercase font-weight-bold font-xs">Importe</div>
                </CCardBody>
              </CCard>
            </div>

            <div class="col-md-3">
              <CCard :no-body="true">
                <CCardBody class="p-0 clearfix" >
                  <i class="fa fa-credit-card text-white p-4 font-2xl mr-3 float-left"
                    :class="stringUtils.getColorBadgePaymentStatus(parkingsPlansClientsToEdit.payment_status)"
                  ></i>
                  <div class="h6 text-dark mb-0 pt-3" v-if="parkingsPlansClientsToEdit.payment_status">
                    <b> {{ stringUtils.getLabelPaymentStatus(parkingsPlansClientsToEdit.payment_status) }}</b></div>
                  <div class="text-muted text-uppercase font-weight-bold font-xs">Estado</div>
                </CCardBody>
              </CCard>
            </div>

          </CRow>


          <CTabs
            :active-tab.sync="activeTab"
            add-tab-classes="container-tabs"
            >

            <CTab active>
              <template slot="title">
                <CIcon name="cil-info"/> Detalle
              </template>


              <CCard>

                <CCardHeader class="card-detail-header">
                  <slot name="header" >
                    <span v-if="parkingsPlansClientsToEdit" class="card-detail-header-title">
                      <i class="fa fa-edit mr-1"></i>
                      {{ elemento }}
                      <span v-if="parkingsPlansClientsToEdit.plan"><strong>{{ parkingsPlansClientsToEdit.plan.name }}</strong></span>
                      <span v-if="productType == CUSTOM.key"><strong>{{ CUSTOM.element }} </strong></span>
                      <span v-if="productType == PRUEBA.key"><strong>{{ PRUEBA.element }} </strong></span>
                      <!-- <span v-if="productType == PRUEBA.key"><strong>{{ PRUEBA.element }} </strong></span> -->
                    </span>

                    <span :class="`text-${stringUtils.getStatusColor(parkingsPlansClientsToEdit.status)}`">
                      {{stringUtils.getLabelStatus(parkingsPlansClientsToEdit.status)}}</span>

                  </slot>

                  <!-- <div class="card-header-actions">
                    <CButton v-if="parkingsPlansClientsToEdit" type="submit" size="sm" color="success" style="float:right;"
                    @submit.prevent
                    @click="editRegularParkingPlanClient">
                      <CIcon name="cil-check-circle"/> Confirmar edición
                    </CButton>
                  </div> -->
                </CCardHeader>

                <CCardBody>

                  <!-- <h5 class="subtitle">Detalle plan contratado</h5>
                    <div class="section"></div> -->

                    <CListGroup>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Plan</strong>
                       <span v-if="parkingsPlansClient.plan">{{parkingsPlansClient.plan.name}}</span>
                       <span v-if="productType == CUSTOM.key">{{ CUSTOM.element }}</span>
                       <span v-if="productType == PRUEBA.key">{{ PRUEBA.element }}</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                        v-if="parkingsPlansClient.custom_text"
                      >
                      <strong>Concepto</strong>
                      <span>{{ parkingsPlansClient.custom_text }}</span>
                      </CListGroupItem>
                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Fecha inicio</strong>
                       <span v-if="parkingsPlansClient.start_datetime">{{formatDateCustom(parkingsPlansClient.start_datetime)}}</span>
                       <span v-else>--</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Fecha fin</strong>
                       <span v-if="parkingsPlansClient.end_datetime">{{formatDateCustom(parkingsPlansClient.end_datetime)}}</span>
                       <span v-else>--</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Hora inicio</strong>
                       <span v-if="parkingsPlansClient.start_datetime">{{formatTime(parkingsPlansClient.start_datetime)}}</span>
                       <span v-else>--</span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Hora fin</strong>
                       <span v-if="parkingsPlansClient.end_datetime">{{formatTime(parkingsPlansClient.end_datetime)}}</span>
                       <span v-else>--</span>

                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Importe</strong>
                       <span>{{parkingsPlansClient.amount}} €</span>
                      </CListGroupItem>

                      <CListGroupItem v-if="parkingsPlansClient.discount"
                        class="d-flex justify-content-between align-items-center" >
                        <strong>Descuento</strong>
                        <span>
                          <span class="mr-4" style="color: gray">({{ parkingsPlansClient.discount }} %)</span>
                          {{ stringUtils.formatStringPrice(parkingsPlansClient.discount_amount) }} €
                        </span>
                      </CListGroupItem>

                      <CListGroupItem v-if="parkingsPlansClient.discount_name"
                        class="d-flex justify-content-between align-items-center" >
                        <strong>Descuento tipo</strong>
                        <span>
                          <span style="color: gray">{{ stringUtils.getDiscountName(parkingsPlansClient.discount_name) }}</span>
                        </span>
                      </CListGroupItem>


                      <CListGroupItem v-if="parkingsPlansClient.discount"
                        class="d-flex justify-content-between align-items-center"
                      >
                        <strong>Total</strong>
                        <span> {{ stringUtils.formatStringPrice(parkingsPlansClient.total_amount) }} € </span>
                      </CListGroupItem>

                      <CListGroupItem
                        class="d-flex justify-content-between align-items-center"
                        v-if="showToggleRenew"
                      >
                      
                       <strong>Renovación automática</strong>
                        <CSwitch class="mx-1"
                          color="primary"
                          variant="3d"
                          shape="square"
                          :checked.sync="parkingsPlansClient.renewal"
                          v-bind="labelIcon"
                          :value="parkingsPlansClient"
                          :disabled="['FINISHED', 'CANCELLED'].includes(parkingsPlansClient.status)" 
                          @update:checked="() => modalRenewProduct = true"
                        />
                        <!-- :disabled="!['NOT_ACTIVE','FREE','ACTIVE'].includes(parkingsPlansClient.status)" -->
                      </CListGroupItem>

                      <CListGroupItem v-if="parkingsPlansClient.renewal && parkingsPlansClient.next_payment_date"
                        class="d-flex justify-content-between align-items-center"
                      >
                       <strong>Fecha de próximo pago</strong>
                      <span>{{ formatDateCustom(parkingsPlansClient.next_payment_date) }}</span>
                      </CListGroupItem>

                    </CListGroup>

                </CCardBody>

                <p class="invalid-feedback d-block m-3">{{ message }}</p>

                <!-- <CCardFooter>
                  <CButton type="submit" size="sm" color="success" style="float:right;" @click="editRegularParkingPlanClient">
                      <CIcon name="cil-check-circle"/> Confirmar edición
                  </CButton>
                </CCardFooter> -->
              </CCard>

            </CTab>

            <!-- Pagos -->
            <CTab>
              <template slot="title">
                <CIcon name="cil-credit-card"/> Pagos
                <CBadge color="success" class="ml-auto" v-if="parkingsPlansClient && payments">{{ payments.length }}</CBadge>
              </template>

              <PaymentsList
                v-bind:payments="payments"
                :elemento="'Pagos'"
                :title="'Listado de Pagos'"
                :loading="loadingPayments"
                @cambiarPagina="cambiarPaginaPayment"
                :rows="pagPayments.rows"
                :pagina_actual="pagPayments.paginaActual"
                :currentPage="pagPayments.currentPage"
                :perPage="pagPayments.perPage"
                :total_paginas="pagPayments.totalPaginas"
              />

            </CTab>


            <!-- Devoluciones -->
            <!-- <CTab>
              <template slot="title">
                <CIcon name="cil-reload"/> Devoluciones
                <CBadge color="success" class="ml-auto" v-if="parkingsPlansClient && refounds">{{ refounds.length }}</CBadge>
              </template>

              <RefoundsList
                v-bind:refounds="refounds"
                :elemento="'Devoluciones'"
                :title="'Listado de Devoluciones'"
                :loading="loadingRefounds"
                @cambiarPagina="cambiarPaginaRefound"
                :rows="pagRefounds.rows"
                :pagina_actual="pagRefounds.paginaActual"
                :currentPage="pagRefounds.currentPage"
                :perPage="pagRefounds.perPage"
                :total_paginas="pagRefounds.totalPaginas"
              />

            </CTab> -->

            <!-- Eventos -->
            <!-- <CTab>
              <template slot="title">
                <CIcon name="cil-calendar"/> Eventos
                <CBadge color="success" class="ml-auto" v-if="parkingsPlansClient && events">{{ events.length }}</CBadge>
              </template>

              <EventsList
                v-bind:events="events"
                :elemento="'Eventos'"
                :title="'Listado de eventos'"
                :loading="loadingEvents"
                @cambiarPagina="cambiarPaginaEvents"
                :rows="pagEvents.rows"
                :pagina_actual="pagEvents.paginaActual"
                :currentPage="pagEvents.currentPage"
                :perPage="pagEvents.perPage"
                :total_paginas="pagEvents.totalPaginas"
              />

            </CTab> -->


            <!-- Estacionamientos -->
            <CTab>
              <template slot="title">
                <CIcon name="cil-grid"/> Estacionamientos
                <CBadge color="success" class="ml-auto" v-if="parkingsPlansClient && stays">{{ stays.length }}</CBadge>
              </template>

              <StaysList
                v-bind:stays="stays"
                elemento="Estacionamientos"
                title="Listado de Estacionamientos"
                :loading="loadingStayings"
                :showHeader="true"
                @cambiarPagina="cambiarPaginaStaying"
                :rows="pagStaying.rows"
                :pagina_actual="pagStaying.paginaActual"
                :perPage="pagStaying.perPage"
                :total_paginas="pagStaying.totalPaginas"
                :currentPage="pagStaying.currentPage"
                @showInvoiceAlert="showStayingBill = true" 
                @updateData="getContractStayings"
              />

            </CTab>


          </CTabs>


        </div>


      </CCol>


    </CRow>



  </transition>

    <StayingBillModal
      :showModal="showStayingBill"
      @update:showModal="showStayingBill=$event"
    />


  <toast ref="toast"></toast>
</div>
</template>

<script>
import { fetchPaymentFromProductAllPlan } from '@/app/shared/global/services/payment-service';
import { fetchEventFromProductAllPlan } from '@/app/shared/global/services/event-service';
import { fetchOneProduct, updateProduct } from '@/app/shared/global/services/product-service';
// import { fetchOneClient } from '@/app/views/clientes/shared/services/clients-service';
import { fetchStayingsFromProductAllPlan } from '@/app/shared/global/services/staying-service';
import { fetchAllPlans } from '@/app/shared/global/services/plan-service';


import { LABEL_ICON, CUSTOM, PRUEBA, BASE, PRODUCT_PERMINUTES } from '@/config';
import stringUtils from "@/app/shared/utils/stringUtils";
import validator from "@/validator";


import BadgeStatus from '@/components/badges/BadgeStatus';
import BadgePaymentStatus from '@/components/badges/BadgePaymentStatus';

import PaymentsList from '@/components/listados/PaymentsList';
// import RefoundsList from '@/components/listados/RefoundsList';
import EventsList from '@/components/listados/EventsList';
import StaysList from '@/components/listados/StaysList';
import StayingBillModal from '../../shared/components/modals/StayingBillModal';

// import CardClient from '@/components/cards/CardClient';
import CardParking from '@/components/cards/CardParking';

import { formatDateTimeCustom, formatDateCustom, formatTime } from '@/app/shared/utils/utils';
import apiTools from '@/app/shared/utils/apiTools';

export default {
  name: 'ClientProductDetail',
  components: {

    BadgeStatus,
    BadgePaymentStatus,
    PaymentsList,
    // RefoundsList,
    EventsList,
    // CardClient,
    CardParking,
    StaysList,
    StayingBillModal
  },
  data() {
    return {
      elemento: "Plan contratado",
      parkingsPlansClientID: null,
      parkingsPlansClient: null,
      parkingsPlansClientsToEdit: null,
      loading: true,
      activeTab: 0,
      message: null,
      productType: 'prepago',
      
      // PAGOS
      payments: [],
      loadingPayments: false,
      pagPayments: {
        paginaActual: 1,
        rows: 0,
        totalPaginas: 1,
        currentPage: 1,
        perPage: 25,
      },

      // Devoluciones
      refounds: [],
      loadingRefounds: false,
      pagRefounds: {
        paginaActual: 1,
        rows: 0,
        totalPaginas: 1,
        currentPage: 1,
        perPage: 25,
      },

      // Eventos
      events: [],
      loadingEvents: false,
      pagEvents: {
        paginaActual: 1,
        rows: 0,
        totalPaginas: 1,
        currentPage: 1,
        perPage: 25,
      },

      // Estacionamientos
      stays: [],
      loadingStayings: false,
      pagStaying: {
        paginaActual: 1,
        rows: 0,
        totalPaginas: 1,
        currentPage: 1,
        perPage: 25,
      },

      labelIcon: LABEL_ICON,
      // client: null,
      // loadingCards: false,
      // creditsCards: [],
      stringUtils: stringUtils,
      apiTools: apiTools,
      formatDateTimeCustom: formatDateTimeCustom,
      formatDateCustom: formatDateCustom,
      formatTime: formatTime,

      modalRenewProduct: false,
      showStayingBill: false,
      CUSTOM: CUSTOM,
      PRUEBA: PRUEBA,
      PRODUCT_PERMINUTES: PRODUCT_PERMINUTES
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.expired) {
      this.$refs.toast.showToast("La sesión ha caducado. Por favor, inicie sesión de nuevo.", null,"error","5000");
    }
  },
  async created(){

    if (this.$route.query && this.$route.query.data){
      this.productType = this.$route.query.data;
    }

    if (this.$route.params.id) {
      this.parkingsPlansClientID = this.$route.params.id;
      this.getParkingPlanClient();
      this.getContractPayments();
      // this.getContractRefounds();
      // this.getContractEvents();

      await this.getPlans();
      await this.getContractStayings();

    } else {
      this.$refs.toast.showToast( "Url incorrecta.", null,"error","2000");
      this.$router.push({path: `/gestion/contrataciones`})
    }

  },
  computed:{
    confirmTitle() {
      return this.parkingsPlansClient && this.parkingsPlansClient.renewal ?
      'Activar renovación automática' :
      'Anular renovación automática'
    },
    showToggleRenew() {
      return this.productType !== 'trial' && !this.parkingsPlansClient.plan_custom_id && this.parkingsPlansClient.plan.id !== 1 && this.parkingsPlansClient.plan.id === 10
    }
  },
  methods: {
    getContractPayments(){

      if (this.productType == PRUEBA.key ) return;

      this.loadingPayments = true;

      fetchPaymentFromProductAllPlan(this.productType, this.parkingsPlansClientID, this.pagPayments.paginaActual)
      .then(resp => {
        if ( resp.status !== 'success' ){
          this.$refs.toast.showToast(`Error al listar pagos del plan contratado`, null, 'error', '2000');
          this.loadingPayments = false;
          return
        }

        this.payments  = [...resp.data.data];

        this.payments.forEach( item => {
          item.checked = false
          item._selected = false
          return item
        });

        this.pagPayments = apiTools.getPaginationData(resp.data);

        this.loadingPayments = false;
      })
      .catch(e => {
        console.log(e);
        this.$refs.toast.showToast(`Error al listar pagos del plan contratado`, null, 'error', '2000');
        this.loadingPayments = false;
      })
    },
    getContractRefounds(){
      this.loadingRefounds = true;

      fetchRefoundFromProductPlan(this.productType, this.parkingsPlansClientID, this.pagRefounds.paginaActual)
      .then(resp => {

        if ( resp.status !== 'success' ){
          this.$refs.toast.showToast(`Error al listar las devoluciones del plan contratado`, null, 'error', '2000');
          this.loadingRefounds = false;
          return
        }

        this.refounds  = [...resp.data.data];

        this.refounds.forEach( item => {
          item.checked = false
          item._selected = false
          return item
        });

        this.pagRefounds = apiTools.getPaginationData(resp.data);

      })
      .catch(e => {
        console.log(e);
        this.$refs.toast.showToast(`Error al listar las devoluciones del plan contratado`, null, 'error', '2000');
      }).finally(() => {
        this.loadingRefounds = false
      })

    },
    getContractEvents(){
      this.loadingEvents = true;
      const errorMessage = 'Error al listar los eventos del plan contratado';

      fetchEventFromProductAllPlan(this.productType, this.parkingsPlansClientID, this.pagEvents.paginaActual)
      .then(resp => {

        if ( resp.status !== 'success' ){
          this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');
          this.loadingEvents = false;
          return
        }

        this.events  = [...resp.data.data];

        this.events.forEach( item => {
          item.checked = false
          item._selected = false
          return item
        });

        this.pagEvents = apiTools.getPaginationData(resp.data);
      })
      .catch(e => {
        console.log(e);
        this.$refs.toast.showToast(`Error al listar los eventos del plan contratado`, null, 'error', '2000');
      }).finally(() => {
        this.loadingEvents = false
      })
    },

    getContractStayings(){
      this.loadingStayings = true;
      const errorMessage = 'Error al listar los estacionamientos del plan contratado';

      fetchStayingsFromProductAllPlan(this.productType, this.parkingsPlansClientID, this.pagStaying.paginaActual)
      .then(resp => {

        if ( resp.status !== 'success' ){
          this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');
          this.loadingStayings = false;
          return
        }

        this.stays  = [...resp.data.data];

        this.stays.forEach( item => {
           item.planes = this.getPlanes(item);
          item.checked = false;
          item._selected = false;
          return item
        });

        this.pagStaying = apiTools.getPaginationData(resp.data);

      }).catch(e => {
        console.log(e);
        this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');
      }).finally(() => {
        this.loadingStayings = false;
      })
    },

    cambiarPaginaPayment(e) {
      this.pagPayments.paginaActual = e;
      this.getContractPayments();
    },
    cambiarPaginaRefound(e) {
      this.pagRefounds.paginaActual = e;
      this.getContractRefounds();
    },
    cambiarPaginaEvents(e) {
      this.pagEvents.paginaActual = e;
      this.getContractEvents();
    },
    cambiarPaginaStaying(e) {
      this.pagStaying.paginaActual = e;
      this.getContractStayings();
    },

    getPlanes(data) {

      let planes = [];

      if (data.parkings_plans_clients.length > 0) {
        data.parkings_plans_clients.forEach(item => {
          planes = [ ...planes, this.getPlanName(item.parkings_plans_client.plans_id)];
          return item;
        });

        // Eliminar duplicados
        planes = [...new Set(planes)];
      }

      if (data.parkings_plans_clients_customs.length > 0) {
        planes = [ ...planes, CUSTOM.element];
      }

      if (data.parkings_plans_clients_trials.length > 0) {
        planes = [ ...planes, PRUEBA.element];
      }

      if (data.parkings_plans_clients_per_minutes.length > 0) {
        planes = [ ...planes, BASE.element]; // this.getPlanName(1)
      }

      return planes;
    },

    getPlanName(planId){
      const data = this.plansList.find(plan => plan.id == planId);
      return data !== undefined ? data.name : '';
    },

    async getPlans(){

      const resp = await fetchAllPlans().catch(e => {
        console.log(e);
        this.$refs.toast.showToast(`Error al obtener los planes`, null, 'error', '2000');
        return
      });

      if (resp.status !== 'success') {
        this.$refs.toast.showToast(`Error al obtener los planes`, null, 'error', '2000');
        return
      }

      this.plansList = [...resp.data];

    },

    async getParkingPlanClient() {

      this.loading = true;

      try {

        let resp = await fetchOneProduct(this.$route.params.id, this.$route.query.data);

        if ( resp.status !== 200) {
          this.$refs.toast.showToast(`Se ha producido un error al cargar`, null, 'error', '5000');
          this.loading = false;

          return
        }

        // if (!resp.data) {
        //   this.$refs.toast.showToast(`Plan custom`, null, 'warn', '5000');
        //   this.$router.push({path: `/gestion/contrataciones`})
        //   return
        // }

        this.parkingsPlansClientsToEdit = resp.data;
        this.parkingsPlansClient = {...this.parkingsPlansClientsToEdit};

        this.loading = false;

        console.log(this.parkingsPlansClient);

      } catch(e) {

        this.$refs.toast.showToast(`Se ha producido un error al cargar`, null, 'error', '5000');
        this.loading = false;

      }
    },


    resetRenewal() {
      this.modalRenewProduct = false;

      this.parkingsPlansClient = {...this.parkingsPlansClientsToEdit};
      this.$forceUpdate();

      // this.getParkingPlanClient();
    },

    async updateRenewal() {

      this.modalRenewProduct = false;
      // this.parkingsPlansClient.renewal = !this.parkingsPlansClient.renewal;

      const errorMessage = 'Se ha producido un error al actualizar la renovación.';

      try {

        this.loading = true;

        let resp = await updateProduct({...this.parkingsPlansClient, product_type: this.$route.query.data });

        if (resp.status !== 'success') {
          console.log(resp);

          this.parkingsPlansClient.renewal = this.parkingsPlansClientsToEdit.renewal;

          this.loading = false;
          if (resp.status == 'warn') {
            this.$refs.toast.showToast( `${resp.message} `, null, "warn", "5000");
            this.message = resp.message;
          } else {
            this.$refs.toast.showToast(`${errorMessage}`, null, "error", "5000");
          }
          return
        }

        this.$refs.toast.showToast( "Plan actualizado", null,"success","2000");
        this.loading = false;

      } catch(e) {
        console.log(e);
        this.$refs.toast.showToast(  `${errorMessage}`, null, "error", "5000");
        this.parkingsPlansClient.renewal = this.parkingsPlansClientsToEdit.renewal;
        this.loading = false;
      }

    },

  }
}
</script>

<style lang="scss">

</style>
